// extracted by mini-css-extract-plugin
export var buttonContainer = "_7m-1";
export var fontSizeSelect = "_7m-3";
export var formatSelect = "_7m-2";
export var formats = "_7m-4";
export var hidden = "_7m-5";
export var icon = "_7m-6";
export var select = "_7m-0";